import _classCallCheck from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/inherits";
import { HachureFiller } from './hachure-filler';
export var ZigZagFiller =
/*#__PURE__*/
function (_HachureFiller) {
  _inherits(ZigZagFiller, _HachureFiller);

  function ZigZagFiller() {
    _classCallCheck(this, ZigZagFiller);

    return _possibleConstructorReturn(this, _getPrototypeOf(ZigZagFiller).apply(this, arguments));
  }

  _createClass(ZigZagFiller, [{
    key: "fillPolygon",
    value: function fillPolygon(points, o) {
      return this._fillPolygon(points, o, true);
    }
  }, {
    key: "fillEllipse",
    value: function fillEllipse(cx, cy, width, height, o) {
      return this._fillEllipse(cx, cy, width, height, o, true);
    }
  }]);

  return ZigZagFiller;
}(HachureFiller);